import { useContext } from 'react'

import { Box, Button, Text } from '@fairfashion/design-system'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

import { StatusTag } from '../../../../components/StatusTag/status-tag.comp'
import { OrderProductionsContext } from '../../order-productions.context'

import * as Styles from './order-productions-table.styles'

export const OrderProductionsTable = () => {
  const { orderProductions } = useContext(OrderProductionsContext)

  const getDate = (date?: Date) => {
    if (!date) {
      return ' - '
    }

    return moment(date).format('DD/MM/YYYY')
  }

  const navigate = useNavigate()

  return (
    <Styles.Wrapper>
      {orderProductions.length === 0 && (
        <Box
          justifyContent="center"
          alignItems="center"
          padding={4}
          minWidth="100%"
        >
          <Text size="small" color="grey_3">
            Nenhum processo produtivo encontrado
          </Text>
        </Box>
      )}
      {orderProductions.map((orderProduction, index) => (
        <Box
          key={`order-production-${index}`}
          justifyContent="space-between"
          alignItems="center"
          padding={2}
          gap={2}
          flex={1}
          minWidth="100%"
        >
          <Styles.Column>
            <Styles.ColumnTitle>Ordem de produção</Styles.ColumnTitle>
            <Styles.ColumnValue>{orderProduction.code}</Styles.ColumnValue>
          </Styles.Column>
          <Styles.Column>
            <Styles.ColumnTitle>SKU</Styles.ColumnTitle>
            <Styles.ColumnValue>
              {orderProduction.itemOrderProductions?.[0]?.code ?? ' - '}
            </Styles.ColumnValue>
          </Styles.Column>
          <Styles.Column>
            <Styles.ColumnTitle>Fábrica</Styles.ColumnTitle>
            <Styles.ColumnValue>
              {orderProduction.clientCompany?.name}
            </Styles.ColumnValue>
          </Styles.Column>
          <Styles.Column>
            <Styles.ColumnTitle>Início da produção</Styles.ColumnTitle>
            <Styles.ColumnValue>
              {getDate(orderProduction.orderProductionSteps?.[0]?.startDate)}
            </Styles.ColumnValue>
          </Styles.Column>
          <Styles.Column>
            <Styles.ColumnTitle>Fim da produção</Styles.ColumnTitle>
            <Styles.ColumnValue>
              {getDate(orderProduction.orderProductionSteps?.at(-1)?.endDate)}
            </Styles.ColumnValue>
          </Styles.Column>
          <Styles.Column alignItems="center">
            <StatusTag status={orderProduction.status} />
          </Styles.Column>
          <Styles.Column alignItems="center">
            <Button
              fontSize="14px"
              padding="10px 14px"
              onClick={() =>
                navigate(`/order-productions/${orderProduction.code}`)
              }
            >
              Detalhes
            </Button>
          </Styles.Column>
        </Box>
      ))}
    </Styles.Wrapper>
  )
}
